module.exports = __webpack_public_path__ + "img/PDF.1fda52f1.svg";